import format from "date-fns/format";
import pl from "date-fns/locale/pl";
import React from "react";
import { BsCalendarDate } from "react-icons/bs";
import { HiOutlineTicket } from "react-icons/hi";
import { Ticket } from "../../../models/Ticket";
import "./styleMobile.scss";
import { TbTicket } from "react-icons/tb";
import { MdEventAvailable } from "react-icons/md";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { State } from "../../../store";
interface IProps {
  ticket: Ticket;
  handleSetOpen: () => void;
  handleSetOpenChangeDate: () => void;
}

const TicketExerciseMobile: React.FC<IProps> = ({ ticket, handleSetOpenChangeDate, handleSetOpen }: IProps) => {
  const locale = useLocaleByLanguage();
  const { t } = useTranslation();
  const allowToChangeDate = useSelector((state: State) => state.config.configuration.allowReservedExerciseChange);

  return (
    <React.Fragment>
      <div className="future-ticket">
        <div className="future-ticket-date flex-start-center">
          <div className="future-ticket-mini-calendar flex-center-center flex-wrap">
            <b>
              {format(ticket.exercises[0].startTime, "MMM", {
                locale: locale,
              })}
            </b>
            <b>
              {format(ticket.exercises[0].startTime, "d", {
                locale: locale,
              })}
            </b>
          </div>

          <div className="future-ticket-date-text flex-column">
            <b>
              {" "}
              {format(ticket.exercises[0].startTime, "cccc", {
                locale: locale,
              })}
            </b>
            <span>
              {t("godz")}: {format(ticket.exercises[0].startTime, "HH:mm")}
            </span>
          </div>
        </div>

        <div className="future-ticket-line"></div>

        <div className="future-ticket-body">
          <div className="flex-start-center">
            <MdEventAvailable className="icon" />
            <b>{ticket.exercises[0].name}</b>
          </div>

          <div className="flex-start-center">
            <TbTicket className="icon" /> <b>{ticket.name}</b>
          </div>
        </div>

        <div className="future-ticket-buttons flex-column">
        <React.Fragment>
              {allowToChangeDate && <button
                onClick={() => handleSetOpenChangeDate()}
                className="button medium padding-medium button-fill-background-main full-button"
              >
                {t("zmien_termin")}
              </button>}
            </React.Fragment>
          <button onClick={() => handleSetOpen()} className="button medium padding-medium button-fill-main full-button">
            {t("pokaz_kod_qr")}
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TicketExerciseMobile;
